const STORAGE_KEY = 'app_observability_session_id';

let memorySessionId = null;

function createSessionId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `sess_${crypto.randomUUID()}`;
  }
  return `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * 初始化观测用 sessionId（与登录 session 无关）。
 * 同一浏览器标签页内刷新页面保持不变。
 */
export function initSessionContext() {
  if (typeof sessionStorage !== 'undefined') {
    let id = sessionStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = createSessionId();
      sessionStorage.setItem(STORAGE_KEY, id);
    }
    memorySessionId = id;
    return id;
  }

  if (!memorySessionId) {
    memorySessionId = createSessionId();
  }
  return memorySessionId;
}

export function getSessionId() {
  if (typeof sessionStorage !== 'undefined') {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      memorySessionId = stored;
      return stored;
    }
  }
  if (!memorySessionId) {
    memorySessionId = createSessionId();
  }
  return memorySessionId;
}
